module.exports = __webpack_public_path__ + "img/acc_carousel_02.d09d9080.jpg";